// Raccolta di atmosfere quotidiane per la parte superiore della home.
// Composizioni leggere e riutilizzabili (sfumature CSS + accenti SVG vettoriali).
// La Fiamma approvata (flame-emblem.webp) resta l'elemento costante.
// Raccolta completa: 14 giornate. Stile pittorico avorio/oro/lilla, spazio libero.
const G = { // sfumature riutilizzabili (colori con alpha nelle layer)
  gold: (a) => `rgba(244,214,165,${a})`,
  goldWarm: (a) => `rgba(238,221,178,${a})`,
  lilac: (a) => `rgba(202,178,222,${a})`,
  lilacDeep: (a) => `rgba(183,155,208,${a})`,
  sage: (a) => `rgba(214,221,196,${a})`,
  sageCool: (a) => `rgba(193,214,207,${a})`,
};

export const ATMOSPHERES = [
  {
    id: "alba", name: "Alba", base: "#F3ECDD", accents: ["dawn", "stars"],
    layers: [
      `radial-gradient(135% 95% at 50% -12%, ${G.gold(0.60)}, ${G.gold(0)} 60%)`,
      `radial-gradient(85% 70% at 82% 18%, ${G.lilac(0.34)}, ${G.lilac(0)} 55%)`,
      `radial-gradient(120% 85% at 18% 112%, ${G.sage(0.42)}, ${G.sage(0)} 60%)`,
    ],
    phrase: "Oggi lascia spazio a ci\u00f2 che senti.",
    action: "Fai tre respiri lenti prima di iniziare.",
  },
  {
    id: "riflessi", name: "Riflessi", base: "#F1ECE1", accents: ["water"],
    layers: [
      `radial-gradient(125% 85% at 50% -8%, ${G.goldWarm(0.55)}, ${G.goldWarm(0)} 58%)`,
      `radial-gradient(100% 65% at 14% 26%, ${G.sageCool(0.42)}, ${G.sageCool(0)} 56%)`,
      `radial-gradient(130% 75% at 86% 120%, ${G.lilac(0.30)}, ${G.lilac(0)} 60%)`,
    ],
    phrase: "Osserva un dettaglio che di solito ti sfugge.",
    action: "Nota un suono intorno a te.",
  },
  {
    id: "fioritura", name: "Fioritura", base: "#F4EEE1", accents: ["flower", "leaves"],
    layers: [
      `radial-gradient(125% 90% at 50% -12%, ${G.gold(0.52)}, ${G.gold(0)} 60%)`,
      `radial-gradient(90% 72% at 24% 18%, ${G.lilacDeep(0.42)}, ${G.lilacDeep(0)} 56%)`,
      `radial-gradient(115% 82% at 82% 116%, ${G.sage(0.46)}, ${G.sage(0)} 60%)`,
    ],
    phrase: "Accogli ci\u00f2 che oggi desidera sbocciare.",
    action: "Concediti un gesto gentile verso di te.",
  },
  {
    id: "quiete", name: "Quiete", base: "#F3EEE3", accents: [],
    layers: [
      `radial-gradient(120% 90% at 50% -10%, ${G.goldWarm(0.48)}, ${G.goldWarm(0)} 62%)`,
      `radial-gradient(95% 70% at 78% 22%, ${G.lilac(0.26)}, ${G.lilac(0)} 55%)`,
      `radial-gradient(120% 80% at 22% 115%, ${G.sageCool(0.34)}, ${G.sageCool(0)} 60%)`,
    ],
    phrase: "Rallenta: non c'\u00e8 nulla da raggiungere adesso.",
    action: "Ammorbidisci lo sguardo e appoggia le spalle.",
  },
  {
    id: "luce-lilla", name: "Luce lilla", base: "#F2ECE2", accents: ["stars"],
    layers: [
      `radial-gradient(120% 88% at 50% -10%, ${G.lilac(0.42)}, ${G.lilac(0)} 60%)`,
      `radial-gradient(90% 70% at 20% 20%, ${G.gold(0.36)}, ${G.gold(0)} 56%)`,
      `radial-gradient(120% 80% at 84% 116%, ${G.lilacDeep(0.30)}, ${G.lilacDeep(0)} 60%)`,
    ],
    phrase: "Dai un nome a ci\u00f2 che provi, senza giudicarlo.",
    action: "Scrivi una parola che ti descrive oggi.",
  },
  {
    id: "acque-calme", name: "Acque calme", base: "#F0ECE2", accents: ["water", "leaves"],
    layers: [
      `radial-gradient(125% 85% at 50% -8%, ${G.goldWarm(0.46)}, ${G.goldWarm(0)} 58%)`,
      `radial-gradient(100% 68% at 16% 28%, ${G.sageCool(0.46)}, ${G.sageCool(0)} 56%)`,
      `radial-gradient(130% 78% at 85% 118%, ${G.sage(0.34)}, ${G.sage(0)} 60%)`,
    ],
    phrase: "Lascia che i pensieri scorrano senza trattenerli.",
    action: "Bevi un sorso d'acqua con calma.",
  },
  {
    id: "primo-sole", name: "Primo sole", base: "#F4ECDB", accents: ["dawn"],
    layers: [
      `radial-gradient(140% 95% at 50% -14%, ${G.gold(0.62)}, ${G.gold(0)} 60%)`,
      `radial-gradient(85% 68% at 80% 18%, ${G.goldWarm(0.36)}, ${G.goldWarm(0)} 55%)`,
      `radial-gradient(120% 82% at 20% 114%, ${G.lilac(0.26)}, ${G.lilac(0)} 60%)`,
    ],
    phrase: "Chiediti di cosa hai davvero bisogno oggi.",
    action: "Fai una cosa piccola solo per te.",
  },
  {
    id: "rugiada", name: "Rugiada", base: "#F1EEE2", accents: ["leaves"],
    layers: [
      `radial-gradient(120% 88% at 50% -10%, ${G.sage(0.5)}, ${G.sage(0)} 60%)`,
      `radial-gradient(90% 70% at 22% 20%, ${G.goldWarm(0.34)}, ${G.goldWarm(0)} 56%)`,
      `radial-gradient(120% 80% at 82% 116%, ${G.sageCool(0.36)}, ${G.sageCool(0)} 60%)`,
    ],
    phrase: "C'\u00e8 bellezza anche in ci\u00f2 che \u00e8 semplice.",
    action: "Osserva qualcosa di vivo vicino a te.",
  },
  {
    id: "cielo-sereno", name: "Cielo sereno", base: "#F2ECDF", accents: ["stars", "dawn"],
    layers: [
      `radial-gradient(135% 92% at 50% -12%, ${G.goldWarm(0.5)}, ${G.goldWarm(0)} 60%)`,
      `radial-gradient(90% 70% at 78% 20%, ${G.lilac(0.32)}, ${G.lilac(0)} 55%)`,
      `radial-gradient(120% 82% at 20% 114%, ${G.sageCool(0.34)}, ${G.sageCool(0)} 60%)`,
    ],
    phrase: "Permettiti di non avere tutte le risposte.",
    action: "Lascia andare una tensione con un respiro.",
  },
  {
    id: "boccio", name: "Boccio", base: "#F4EEE1", accents: ["flower"],
    layers: [
      `radial-gradient(122% 90% at 50% -10%, ${G.lilacDeep(0.4)}, ${G.lilacDeep(0)} 60%)`,
      `radial-gradient(90% 72% at 26% 18%, ${G.gold(0.4)}, ${G.gold(0)} 56%)`,
      `radial-gradient(115% 82% at 80% 116%, ${G.sage(0.4)}, ${G.sage(0)} 60%)`,
    ],
    phrase: "Qualcosa dentro di te sta maturando.",
    action: "Annota un piccolo desiderio.",
  },
  {
    id: "brezza", name: "Brezza", base: "#F1ECE2", accents: ["leaves", "stars"],
    layers: [
      `radial-gradient(120% 88% at 50% -10%, ${G.goldWarm(0.46)}, ${G.goldWarm(0)} 60%)`,
      `radial-gradient(90% 70% at 20% 22%, ${G.sage(0.4)}, ${G.sage(0)} 56%)`,
      `radial-gradient(120% 80% at 84% 116%, ${G.lilac(0.28)}, ${G.lilac(0)} 60%)`,
    ],
    phrase: "Alleggerisci ci\u00f2 che porti, anche solo un poco.",
    action: "Sgombra un piccolo spazio intorno a te.",
  },
  {
    id: "riva-dorata", name: "Riva dorata", base: "#F3ECDC", accents: ["water", "dawn"],
    layers: [
      `radial-gradient(135% 92% at 50% -12%, ${G.gold(0.56)}, ${G.gold(0)} 60%)`,
      `radial-gradient(100% 66% at 16% 28%, ${G.sageCool(0.38)}, ${G.sageCool(0)} 56%)`,
      `radial-gradient(130% 78% at 85% 118%, ${G.goldWarm(0.3)}, ${G.goldWarm(0)} 60%)`,
    ],
    phrase: "Torna al respiro ogni volta che ti perdi.",
    action: "Conta cinque respiri lenti.",
  },
  {
    id: "sera-lilla", name: "Sera lilla", base: "#F1EADF", accents: ["stars"],
    layers: [
      `radial-gradient(122% 90% at 50% -10%, ${G.lilac(0.44)}, ${G.lilac(0)} 60%)`,
      `radial-gradient(90% 70% at 76% 22%, ${G.lilacDeep(0.3)}, ${G.lilacDeep(0)} 55%)`,
      `radial-gradient(120% 80% at 22% 115%, ${G.goldWarm(0.3)}, ${G.goldWarm(0)} 60%)`,
    ],
    phrase: "Ringrazia te stessa per come sei arrivata fin qui.",
    action: "Ricorda un momento gentile di oggi.",
  },
  {
    id: "nuovo-inizio", name: "Nuovo inizio", base: "#F4EEE0", accents: ["flower", "dawn"],
    layers: [
      `radial-gradient(135% 92% at 50% -12%, ${G.gold(0.54)}, ${G.gold(0)} 60%)`,
      `radial-gradient(90% 72% at 24% 18%, ${G.lilac(0.36)}, ${G.lilac(0)} 56%)`,
      `radial-gradient(115% 82% at 82% 116%, ${G.sage(0.42)}, ${G.sage(0)} 60%)`,
    ],
    phrase: "Ogni giorno puoi ricominciare con dolcezza.",
    action: "Posa una mano sul cuore per un istante.",
  },
];

// Selezione deterministica per data locale: stessa atmosfera per tutto il giorno,
// cambia il giorno dopo, nessuna ripetizione consecutiva, invariata ai refresh.
export function atmosphereForToday(now = new Date()) {
  const localMidnightDay = Math.floor((now.getTime() - now.getTimezoneOffset() * 60000) / 86400000);
  const n = ATMOSPHERES.length;
  const idx = ((localMidnightDay % n) + n) % n;
  return ATMOSPHERES[idx];
}
